const DATASET = { dataset:
   { 'week-1':
      [ { date: '2019-11-11', day: 'Sunday', contribCount: 3 },
        { date: '2019-11-12', day: 'Monday', contribCount: 8 },
        { date: '2019-11-13', day: 'Tuesday', contribCount: 4 },
        { date: '2019-11-14', day: 'Wednesday', contribCount: 7 },
        { date: '2019-11-15', day: 'Thursday', contribCount: 5 },
        { date: '2019-11-16', day: 'Friday', contribCount: 1 },
        { date: '2019-11-17', day: 'Saturday', contribCount: 8 } ],
     'week-2':
      [ { date: '2019-11-18', day: 'Sunday', contribCount: 1 },
        { date: '2019-11-19', day: 'Monday', contribCount: 5 },
        { date: '2019-11-20', day: 'Tuesday', contribCount: 1 },
        { date: '2019-11-21', day: 'Wednesday', contribCount: 4 },
        { date: '2019-11-22', day: 'Thursday', contribCount: 7 },
        { date: '2019-11-23', day: 'Friday', contribCount: 8 },
        { date: '2019-11-24', day: 'Saturday', contribCount: 4 } ],
     'week-3':
      [ { date: '2019-11-25', day: 'Sunday', contribCount: 4 },
        { date: '2019-11-26', day: 'Monday', contribCount: 7 },
        { date: '2019-11-27', day: 'Tuesday', contribCount: 0 },
        { date: '2019-11-28', day: 'Wednesday', contribCount: 5 },
        { date: '2019-11-29', day: 'Thursday', contribCount: 9 },
        { date: '2019-11-30', day: 'Friday', contribCount: 6 },
        { date: '2019-12-1', day: 'Saturday', contribCount: 6 } ],
     'week-4':
      [ { date: '2019-12-2', day: 'Sunday', contribCount: 4 },
        { date: '2019-12-3', day: 'Monday', contribCount: 5 },
        { date: '2019-12-4', day: 'Tuesday', contribCount: 1 },
        { date: '2019-12-5', day: 'Wednesday', contribCount: 3 },
        { date: '2019-12-6', day: 'Thursday', contribCount: 0 },
        { date: '2019-12-7', day: 'Friday', contribCount: 4 },
        { date: '2019-12-8', day: 'Saturday', contribCount: 4 } ],
     'week-5':
      [ { date: '2019-12-9', day: 'Sunday', contribCount: 8 },
        { date: '2019-12-10', day: 'Monday', contribCount: 2 },
        { date: '2019-12-11', day: 'Tuesday', contribCount: 1 },
        { date: '2019-12-12', day: 'Wednesday', contribCount: 1 },
        { date: '2019-12-13', day: 'Thursday', contribCount: 4 },
        { date: '2019-12-14', day: 'Friday', contribCount: 2 },
        { date: '2019-12-15', day: 'Saturday', contribCount: 3 } ],
     'week-6':
      [ { date: '2019-12-16', day: 'Sunday', contribCount: 3 },
        { date: '2019-12-17', day: 'Monday', contribCount: 10 },
        { date: '2019-12-18', day: 'Tuesday', contribCount: 7 },
        { date: '2019-12-19', day: 'Wednesday', contribCount: 9 },
        { date: '2019-12-20', day: 'Thursday', contribCount: 4 },
        { date: '2019-12-21', day: 'Friday', contribCount: 3 },
        { date: '2019-12-22', day: 'Saturday', contribCount: 4 } ],
     'week-7':
      [ { date: '2019-12-23', day: 'Sunday', contribCount: 2 },
        { date: '2019-12-24', day: 'Monday', contribCount: 0 },
        { date: '2019-12-25', day: 'Tuesday', contribCount: 4 },
        { date: '2019-12-26', day: 'Wednesday', contribCount: 5 },
        { date: '2019-12-27', day: 'Thursday', contribCount: 1 },
        { date: '2019-12-28', day: 'Friday', contribCount: 8 },
        { date: '2019-12-29', day: 'Saturday', contribCount: 4 } ],
     'week-8':
      [ { date: '2019-12-30', day: 'Sunday', contribCount: 3 },
        { date: '2019-12-31', day: 'Monday', contribCount: 5 },
        { date: '2020-1-1', day: 'Tuesday', contribCount: 8 },
        { date: '2020-1-2', day: 'Wednesday', contribCount: 9 },
        { date: '2020-1-3', day: 'Thursday', contribCount: 7 },
        { date: '2020-1-4', day: 'Friday', contribCount: 8 },
        { date: '2020-1-5', day: 'Saturday', contribCount: 6 } ],
     'week-9':
      [ { date: '2020-1-6', day: 'Sunday', contribCount: 7 },
        { date: '2020-1-7', day: 'Monday', contribCount: 0 },
        { date: '2020-1-8', day: 'Tuesday', contribCount: 7 },
        { date: '2020-1-9', day: 'Wednesday', contribCount: 1 },
        { date: '2020-1-10', day: 'Thursday', contribCount: 8 },
        { date: '2020-1-11', day: 'Friday', contribCount: 3 },
        { date: '2020-1-12', day: 'Saturday', contribCount: 6 } ],
     'week-10':
      [ { date: '2020-1-13', day: 'Sunday', contribCount: 4 },
        { date: '2020-1-14', day: 'Monday', contribCount: 1 },
        { date: '2020-1-15', day: 'Tuesday', contribCount: 7 },
        { date: '2020-1-16', day: 'Wednesday', contribCount: 2 },
        { date: '2020-1-17', day: 'Thursday', contribCount: 7 },
        { date: '2020-1-18', day: 'Friday', contribCount: 4 },
        { date: '2020-1-19', day: 'Saturday', contribCount: 2 } ] },
  userInfo:
   { avatar_url: null,
     name: null,
     github_username: null,
     joinedYear: '2019',
     joinedDate: '2019-06-01' } }
export default DATASET